// extracted by mini-css-extract-plugin
module.exports = {"formBox":"styles_formBox__-8JD6"};